import type * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubjectFaQsQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type SubjectFaQsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string, userHasAccess?: boolean | null, hasAccessViaLicenseAsStudent?: boolean | null, subscriptionsPrices?: Array<any> | null, countOfQuestions?: number | null, countOfFreeResponseQuestions?: number | null, subjectFaqs: Array<{ __typename?: 'SubjectFaq', id: string, question?: string | null, answer?: string | null, orderPosition?: number | null }> }> | null } | null };

export type CreateSubjectFaqMutationVariables = Types.Exact<{
  subjectId: Types.Scalars['ID']['input'];
  question?: Types.InputMaybe<Types.Scalars['String']['input']>;
  answer?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateSubjectFaqMutation = { __typename?: 'RootMutationType', createSubjectFaq: { __typename?: 'CreateSubjectFaqResult', result?: { __typename?: 'SubjectFaq', id: string, question?: string | null, answer?: string | null, orderPosition?: number | null } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null, fields?: Array<string> | null }> } };

export type UpdateSubjectFaqMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  question?: Types.InputMaybe<Types.Scalars['String']['input']>;
  answer?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateSubjectFaqMutation = { __typename?: 'RootMutationType', updateSubjectFaq: { __typename?: 'UpdateSubjectFaqResult', result?: { __typename?: 'SubjectFaq', id: string, question?: string | null, answer?: string | null, orderPosition?: number | null } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null, fields?: Array<string> | null }> } };

export type DestroySubjectFaqMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DestroySubjectFaqMutation = { __typename?: 'RootMutationType', destroySubjectFaq: { __typename?: 'DestroySubjectFaqResult', result?: { __typename?: 'SubjectFaq', id: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null, fields?: Array<string> | null }> } };

export type ReorderSubjectFaqsMutationVariables = Types.Exact<{
  subjectId: Types.Scalars['ID']['input'];
  newOrder: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ReorderSubjectFaqsMutation = { __typename?: 'RootMutationType', reorderSubjectFaqs: boolean };


export const SubjectFaQsDocument = gql`
    query SubjectFAQs($slug: String!) {
  subjects(filter: {urlSlug: {eq: $slug}}, first: 1) {
    results {
      id
      name
      urlSlug
      userHasAccess
      hasAccessViaLicenseAsStudent
      subscriptionsPrices
      countOfQuestions
      countOfFreeResponseQuestions
      subjectFaqs(sort: [{field: ORDER_POSITION, order: ASC}]) {
        id
        question
        answer
        orderPosition
      }
    }
  }
}
    `;

/**
 * __useSubjectFaQsQuery__
 *
 * To run a query within a React component, call `useSubjectFaQsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectFaQsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectFaQsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSubjectFaQsQuery(baseOptions: Apollo.QueryHookOptions<SubjectFaQsQuery, SubjectFaQsQueryVariables> & ({ variables: SubjectFaQsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectFaQsQuery, SubjectFaQsQueryVariables>(SubjectFaQsDocument, options);
      }
export function useSubjectFaQsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectFaQsQuery, SubjectFaQsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectFaQsQuery, SubjectFaQsQueryVariables>(SubjectFaQsDocument, options);
        }
// @ts-ignore
export function useSubjectFaQsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubjectFaQsQuery, SubjectFaQsQueryVariables>): Apollo.UseSuspenseQueryResult<SubjectFaQsQuery, SubjectFaQsQueryVariables>;
export function useSubjectFaQsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectFaQsQuery, SubjectFaQsQueryVariables>): Apollo.UseSuspenseQueryResult<SubjectFaQsQuery | undefined, SubjectFaQsQueryVariables>;
export function useSubjectFaQsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectFaQsQuery, SubjectFaQsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectFaQsQuery, SubjectFaQsQueryVariables>(SubjectFaQsDocument, options);
        }
export type SubjectFaQsQueryHookResult = ReturnType<typeof useSubjectFaQsQuery>;
export type SubjectFaQsLazyQueryHookResult = ReturnType<typeof useSubjectFaQsLazyQuery>;
export type SubjectFaQsSuspenseQueryHookResult = ReturnType<typeof useSubjectFaQsSuspenseQuery>;
export type SubjectFaQsQueryResult = Apollo.QueryResult<SubjectFaQsQuery, SubjectFaQsQueryVariables>;
export const CreateSubjectFaqDocument = gql`
    mutation CreateSubjectFaq($subjectId: ID!, $question: String, $answer: String) {
  createSubjectFaq(
    input: {subjectId: $subjectId, question: $question, answer: $answer}
  ) {
    result {
      id
      question
      answer
      orderPosition
    }
    errors {
      message
      fields
    }
  }
}
    `;
export type CreateSubjectFaqMutationFn = Apollo.MutationFunction<CreateSubjectFaqMutation, CreateSubjectFaqMutationVariables>;

/**
 * __useCreateSubjectFaqMutation__
 *
 * To run a mutation, you first call `useCreateSubjectFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubjectFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubjectFaqMutation, { data, loading, error }] = useCreateSubjectFaqMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      question: // value for 'question'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useCreateSubjectFaqMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubjectFaqMutation, CreateSubjectFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubjectFaqMutation, CreateSubjectFaqMutationVariables>(CreateSubjectFaqDocument, options);
      }
export type CreateSubjectFaqMutationHookResult = ReturnType<typeof useCreateSubjectFaqMutation>;
export type CreateSubjectFaqMutationResult = Apollo.MutationResult<CreateSubjectFaqMutation>;
export type CreateSubjectFaqMutationOptions = Apollo.BaseMutationOptions<CreateSubjectFaqMutation, CreateSubjectFaqMutationVariables>;
export const UpdateSubjectFaqDocument = gql`
    mutation UpdateSubjectFaq($id: ID!, $question: String, $answer: String) {
  updateSubjectFaq(id: $id, input: {question: $question, answer: $answer}) {
    result {
      id
      question
      answer
      orderPosition
    }
    errors {
      message
      fields
    }
  }
}
    `;
export type UpdateSubjectFaqMutationFn = Apollo.MutationFunction<UpdateSubjectFaqMutation, UpdateSubjectFaqMutationVariables>;

/**
 * __useUpdateSubjectFaqMutation__
 *
 * To run a mutation, you first call `useUpdateSubjectFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubjectFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubjectFaqMutation, { data, loading, error }] = useUpdateSubjectFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *      question: // value for 'question'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useUpdateSubjectFaqMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubjectFaqMutation, UpdateSubjectFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubjectFaqMutation, UpdateSubjectFaqMutationVariables>(UpdateSubjectFaqDocument, options);
      }
export type UpdateSubjectFaqMutationHookResult = ReturnType<typeof useUpdateSubjectFaqMutation>;
export type UpdateSubjectFaqMutationResult = Apollo.MutationResult<UpdateSubjectFaqMutation>;
export type UpdateSubjectFaqMutationOptions = Apollo.BaseMutationOptions<UpdateSubjectFaqMutation, UpdateSubjectFaqMutationVariables>;
export const DestroySubjectFaqDocument = gql`
    mutation DestroySubjectFaq($id: ID!) {
  destroySubjectFaq(id: $id) {
    result {
      id
    }
    errors {
      message
      fields
    }
  }
}
    `;
export type DestroySubjectFaqMutationFn = Apollo.MutationFunction<DestroySubjectFaqMutation, DestroySubjectFaqMutationVariables>;

/**
 * __useDestroySubjectFaqMutation__
 *
 * To run a mutation, you first call `useDestroySubjectFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySubjectFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySubjectFaqMutation, { data, loading, error }] = useDestroySubjectFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroySubjectFaqMutation(baseOptions?: Apollo.MutationHookOptions<DestroySubjectFaqMutation, DestroySubjectFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroySubjectFaqMutation, DestroySubjectFaqMutationVariables>(DestroySubjectFaqDocument, options);
      }
export type DestroySubjectFaqMutationHookResult = ReturnType<typeof useDestroySubjectFaqMutation>;
export type DestroySubjectFaqMutationResult = Apollo.MutationResult<DestroySubjectFaqMutation>;
export type DestroySubjectFaqMutationOptions = Apollo.BaseMutationOptions<DestroySubjectFaqMutation, DestroySubjectFaqMutationVariables>;
export const ReorderSubjectFaqsDocument = gql`
    mutation ReorderSubjectFaqs($subjectId: ID!, $newOrder: [ID!]!) {
  reorderSubjectFaqs(subjectId: $subjectId, newOrder: $newOrder)
}
    `;
export type ReorderSubjectFaqsMutationFn = Apollo.MutationFunction<ReorderSubjectFaqsMutation, ReorderSubjectFaqsMutationVariables>;

/**
 * __useReorderSubjectFaqsMutation__
 *
 * To run a mutation, you first call `useReorderSubjectFaqsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderSubjectFaqsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderSubjectFaqsMutation, { data, loading, error }] = useReorderSubjectFaqsMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      newOrder: // value for 'newOrder'
 *   },
 * });
 */
export function useReorderSubjectFaqsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderSubjectFaqsMutation, ReorderSubjectFaqsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderSubjectFaqsMutation, ReorderSubjectFaqsMutationVariables>(ReorderSubjectFaqsDocument, options);
      }
export type ReorderSubjectFaqsMutationHookResult = ReturnType<typeof useReorderSubjectFaqsMutation>;
export type ReorderSubjectFaqsMutationResult = Apollo.MutationResult<ReorderSubjectFaqsMutation>;
export type ReorderSubjectFaqsMutationOptions = Apollo.BaseMutationOptions<ReorderSubjectFaqsMutation, ReorderSubjectFaqsMutationVariables>;